import React, { useState, useEffect } from 'react';
import { authApi } from '../../services/api';
import Seo from '../common/Seo';
import AdminLogin from './AdminLogin';
import CategoryManagement from './CategoryManagement';
import ItemManagement from './ItemManagement';
import OrdersManagement from './OrdersManagement';
import './AdminView.css';

const AdminView: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState<'categories' | 'items' | 'orders'>('items');

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = () => {
        const authenticated = authApi.isAuthenticated();
        setIsAuthenticated(authenticated);
        setLoading(false);
    };

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        authApi.logout();
        setIsAuthenticated(false);
    };

    if (loading) {
        return (
            <>
                <Seo title="Admin | Namma Nesavu Nool" noindex />
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            </>
        );
    }

    if (!isAuthenticated) {
        return (
            <>
                <Seo title="Admin Login | Namma Nesavu Nool" noindex />
                <AdminLogin onLogin={handleLogin} />
            </>
        );
    }

    return (
        <div className="admin-view">
            <Seo title="Admin | Namma Nesavu Nool" noindex />
            <header className="admin-header">
                <div className="container">
                    <div className="header-content">
                        <div className="logo">
                            <h1>Namma Nesavu Nool - Admin Panel</h1>
                        </div>
                        <nav className="admin-nav">
                            <button
                                className={`nav-btn ${activeTab === 'categories' ? 'active' : ''}`}
                                onClick={() => setActiveTab('categories')}
                            >
                                Categories
                            </button>
                            <button
                                className={`nav-btn ${activeTab === 'items' ? 'active' : ''}`}
                                onClick={() => setActiveTab('items')}
                            >
                                Items
                            </button>
                            <button
                                className={`nav-btn ${activeTab === 'orders' ? 'active' : ''}`}
                                onClick={() => setActiveTab('orders')}
                            >
                                Orders
                            </button>
                        </nav>
                        <div className="admin-actions">
                            <a href="/" className="view-site-btn">
                                View Site
                            </a>
                            <button className="logout-btn" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <main className="admin-main">
                <div className="container">
                    {activeTab === 'categories' && <CategoryManagement />}
                    {activeTab === 'items' && <ItemManagement />}
                    {activeTab === 'orders' && <OrdersManagement />}
                </div>
            </main>
        </div>
    );
};

export default AdminView;
